import { neutralDark30, neutralDark40 } from "./colors";

/**
 * @deprecated This object is being removed in V6+, February 2025
 */
export const tag = {
    fontWeight: 500,
    lineHeight: 18,
    size: 14,
};

/**
 * Field labels, section headers
 * @deprecated This object is being removed in V6+, February 2025
 */
export const title = {
    lineHeight: 18,
    size: 13,
    color: neutralDark30,
};

/**
 * @deprecated This object is being removed in V6+, February 2025
 */
export const body = {
    fontWeight: 400,
    lineHeight: 18,
    size: 15,
    color: neutralDark40,
};
